import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {property} from 'lit/decorators/property.js';

@customElement('visual-lightdistribution')
export class VisualLightengine extends LitElement {

	static styles = css`
	  :host {
		display: flex;
	  }
	`;

	@property({type: Object})
	section = {};

	render() {
		return html`
			<svg-lightdistribution></svg-lightdistribution>
		`;
	}
}
